<template>
    <b-card no-body class="AdminMatchesSectorContainer shadow">
        <div
                v-bind:style="{
                backgroundColor : `${sectorColor.light}`
                }"
                class="AdminMatchesSectorContainer-header text-truncate">
            {{sector.name}}
        </div>
        <div class="AdminMatchesSectorContainer-body">
            <div class="AdminMatchesSectorContainer-radial">
                <radial-progress-bar :diameter="150"
                                     innerStrokeColor="#bbbbbbb5"
                                     :startColor="sectorColor.light"
                                     :stopColor="sectorColor.dark"
                                     :completed-steps="busy"
                                     :total-steps="totalSteps">
                </radial-progress-bar>
            </div>
            <p class="text-center">Occupati {{ busy }} di {{sector.availability}}</p>
            <inter-input
                    v-model="sector.availability"
                    icon="armchair"
                    :error="error">
            </inter-input>

        </div>
    </b-card>
</template>

<script>
    import InterInput from "../../../../components/form/inter-input/InterInput";
    import RadialProgressBar from "vue-radial-progress";

    export default {
        name: "AdminMatchesSectorContainer",
        components: {RadialProgressBar, InterInput},
        data() {
            return {
                error: false
            }
        },
        props: {
            sector: {
                type: Object,
                default: () => {}
            },
            busy: {
                type: Number,
                default: 0
            }
        },
        computed: {
            totalSteps: function () {
                return (this.sector && this.sector.availability) ? parseInt(this.sector.availability) : 1;
            },

            sectorColor: function () {
                switch (this.sector.slug) {
                    case 'secondo-blu':
                        return { light: '#1A639A', dark: '#1A639A' };
                    case 'secondo-rosso':
                        return { light: '#ff1f29', dark: '#ff1f29' };
                    case 'secondo-arancio':
                        return { light: '#ff982c', dark: '#ff982c' };
                    case 'terzo-rosso':
                        return { light: '#ff4a27', dark: '#ff4a27' };
                    case 'unico':
                        return { light: '#ac45df', dark: '#ac45df' };
                    default:
                        return { light: '#1A639A', dark: '#1A639A' };

                }
            },
        }
    }
</script>

<style scoped>

</style>
